import * as React from "react";
import { locKeys } from "components/flexComponents/WizardFlightPWA/components/l10n";
import { FlightTypeMenuProps, FlightTypeMenuItem } from "components/flexComponents/WizardFlightPWA/typings";
import { observer } from "mobx-react";
import { UitkMenu, UitkMenuTrigger, UitkMenuContainer, PositionType, UitkMenuList } from "uitk-react-menu";
import { UitkIcon, UitkIconSize } from "uitk-react-icons";
import { useLocalization } from "@shared-ui/localization-context";
import { FlightType } from "src/stores/wizard/state/flight/typings";
import { UitkLink, UitkLinkAlign } from "uitk-react-link";

export const FlightTypeMenu = observer((props: FlightTypeMenuProps) => {
  const { formatText } = useLocalization();

  function createMenuItem(locKey: string, pwaSubLob: string): FlightTypeMenuItem {
    const urlToGo = props.getFlightURL ? props.getFlightURL("pwaSubLOB", pwaSubLob)() : "#";

    return {
      attributes: {
        role: "menuItem",
        tabindex: 0,
      },
      className: "uitk-list-item",
      href: urlToGo,
      label: formatText(locKey),
      onClick: props.onSubLOBMenuItemClick(pwaSubLob),
      typeAnchor: true,
    };
  }

  const menuItems: FlightTypeMenuItem[] = [];
  menuItems.push(createMenuItem(locKeys.flightRoundTripText, FlightType.ROUND_TRIP));
  if (props.showOneway !== false) {
    menuItems.push(createMenuItem(locKeys.flightOneWayText, FlightType.ONE_WAY));
  }
  if (props.showMulticity !== false) {
    menuItems.push(createMenuItem(locKeys.flightMultiCityText, FlightType.MULTI_CITY));
  }

  /* istanbul ignore next */
  const onTriggerClick = (event: React.MouseEvent) => {
    event.preventDefault();
    props.onSubLOBMenuTriggerClick();
  };

  return (
    <UitkMenu id="flight-type-menu" isOpen={props.isSubLOBMenuOpen} onTriggerClick={onTriggerClick}>
      <UitkMenuTrigger>
        <UitkLink iconPos={UitkLinkAlign.RIGHT}>
          <a href="" className="flight-menu" role="button">
            {props.setFlightType()}
            <UitkIcon name="expand_more" size={UitkIconSize.SMALL} />
          </a>
        </UitkLink>
      </UitkMenuTrigger>
      <UitkMenuContainer position={PositionType.LEFT}>
        <UitkMenuList items={menuItems} />
      </UitkMenuContainer>
    </UitkMenu>
  );
});
